import React from "react"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import RoomTable from "./RoomsTable"


export default function RoomsList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Rooms")} />
        <RoomTable />
      </div>
    </div>
  )
}
